import { getSingleFeedback } from "../../data/dataApi";
import ContentWrapper from "../../views/components/ContentWrapper";
import { useEffect, useState, useRef } from 'react';
import { useParams, Link, useNavigate, useLocation } from 'react-router-dom';
import { ReactComponent as ThumbUpOn } from "../../images/thumb-up-on.svg";
import { ReactComponent as ThumbUpOff } from "../../images/thumb-up-off.svg";
import { ReactComponent as ThumbDownOn } from "../../images/thumb-down-on.svg";
import { ReactComponent as ThumbDownOff } from "../../images/thumb-down-off.svg";
import { Form, Button } from "react-bootstrap";
import ConfirmationModal from "../../views/components/ConfirmationModal";
import { addBotInfo } from "../../data/dataApi";
import { useUserState } from "../../views/components/Mode";

const SingleFeedback = () => {
    const { userRole, userCapabilities } = useUserState();

    const [singleFeedback, setSingleFeedback] = useState(); 
    const { id } = useParams();
    const navigate = useNavigate();
    const location = useLocation();
    const [informValue, setInformValue] = useState('');
    const [informError, setInformError] = useState('');
    const [showConfirmationModal, setShowConfirmationModal] = useState(false);
    const [submittingBotInfo, setSubmittingBotInfo] = useState(false);

    const formRef = useRef(null);

    const handleSubmit = async (event) => {
        setSubmittingBotInfo(true);
        event.preventDefault();

        setInformError("");

        if(informValue.trim() === "") {
            setInformError("Please type new content.");
        } else {
            const response = await addBotInfo(informValue);

            if(response.success) {
                setInformValue("");
                setShowConfirmationModal(true);
            } else {
                setInformError(response.error.message);
            }
        }
        setSubmittingBotInfo(false);
    };

    useEffect(() => {
        (async () => {
            const response = await getSingleFeedback(id);
                        
            if(response.success) {
                setSingleFeedback(response.data.rows[0]);
            }
        })();
    }, [id]);

    return (
        <ContentWrapper className="scrollable">
            <div className="back-wrapper">
                <button className="tertiary-btn"
                    onClick={() => {
                        if (location.key === 'default') {
                        navigate('/history')
                        } else {
                        navigate(-1)
                        }
                    }}>
                    Back
                </button>
            </div>
            <div className="wrapper tif-bg-color-alpha tif-bg-light-color-white">
                <div className="table-wrapper">
                    <table className="secondary-table w-100">
                        {singleFeedback && <tbody className="secondary-body">
                            <tr>
                                <td width={238}><b>ID</b></td>
                                <td>{singleFeedback.id}</td>
                            </tr>
                            <tr>
                                <td><b>User IP</b></td>
                                <td>{singleFeedback.user_ip}</td>
                            </tr>
                            <tr>
                                <td><b>Country</b></td>
                                <td>{singleFeedback.country}</td>
                            </tr>
                            <tr>
                                <td><b>Time</b></td>
                                <td>{singleFeedback.time}</td>
                            </tr>
                            <tr>
                                <td><b>User Feedback</b></td>
                                <td>{singleFeedback.user_feedback}</td>
                            </tr>
                            <tr>
                                <td><b>Reason</b></td>
                                <td>{singleFeedback.reason && JSON.parse(singleFeedback.reason).map((reason, reasonIndex) => (
                                        <div key={reasonIndex}>{reason}</div>
                                    ))}
                                </td>
                            </tr>
                            <tr>
                                <td><b>User message</b></td>
                                <td>{singleFeedback.user_message}</td>
                            </tr>
                            <tr>
                                <td><b>Response</b></td>
                                <td>{singleFeedback.api_response}</td>
                            </tr>
                            <tr>
                                <td><b>Rating</b></td>
                                <td><div className="rating-cell">
                                        {
                                            singleFeedback.rating === "up" ?
                                                <>
                                                    <div>
                                                        <ThumbUpOn className="thumb-up-on tif-ml-md-5 tif-ml-0" />
                                                        <ThumbDownOff className="thumb-down-off tif-ml-md-10 tif-ml-5" />
                                                    </div>
                                                </>
                                            :
                                                <>
                                                    <div>
                                                        <ThumbUpOff className="thumb-up-off tif-ml-md-5 tif-ml-0" />
                                                        <ThumbDownOn className="thumb-down-on tif-ml-md-10 tif-ml-5" />
                                                    </div>
                                                    
                                                    {
                                                        userRole === "admin" &&
                                                        <Button className="link-out"
                                                            onClick={() => {
                                                                if (formRef.current) {
                                                                    formRef.current.scrollIntoView({ behavior: 'smooth' });
                                                                }
                                                            }}>
                                                            Inform the Bot
                                                        </Button>
                                                    }
                                                </>
                                        }
                                    </div>
                                </td>
                            </tr>
                            <tr>
                                <td><b>Chat History</b></td>
                                <td>
                                    <Link to={`/history/${singleFeedback.session_id}`} className="link-out">View</Link>
                                </td>
                            </tr>
                        </tbody>}

                    </table>

                    {
                        (userCapabilities.includes("create_inform_the_bot") && singleFeedback && singleFeedback.rating === "down") &&
                        <>
                            <table className="secondary-table w-100 tif-mb-35 tif-mt-85">
                                <thead>
                                    <tr>
                                        <td>Inform the Bot</td>
                                    </tr>
                                </thead>
                            </table>

                            <Form ref={formRef} className="secondary-form" onSubmit={handleSubmit}>
                                <Form.Group className="form-group" controlId="formTextArea">
                                    <Form.Label>Type correct answer to the question below.</Form.Label>
                                    <Form.Control
                                        as="textarea"
                                        rows={1}
                                        value={informValue}
                                        onChange={(e) => setInformValue(e.target.value)}
                                        placeholder="Type here"
                                    />
                                </Form.Group>
                                { informError && <p className="error-text">{ informError }</p> }
                                <Button className="quarternary-btn tif-mt-155" type="submit" disabled={submittingBotInfo}>
                                    { submittingBotInfo ? "Saving..." : "Save" }
                                </Button>
                            </Form>
                        </>
                    }
                </div>
            </div>
            <ConfirmationModal 
                show={showConfirmationModal}
                changeVisibility={setShowConfirmationModal} 
                type="success"
                successMessage="You have successfully added new information."
                close={
                    <Button className="tertiary-btn" onClick={() => setShowConfirmationModal(false)}>
                        Back to Feedback
                    </Button>
                }
            />
        </ContentWrapper>
    );
}

export default SingleFeedback;